export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEKRXh0LVJLU0otSGEMgUEBvU8AAMBMAADAUgUAwFAAAMBPDwK9UwIEvVYAAMBZAADAVAAAwFcAAMBWABG9W0EYgYvATQAGABIeG4FyhUEBAAEAAQABABkAHwABAAEABgBTAAEAAQABAAEAGQAgAAEAAQAGAGEDg5UBvgKHSA++BBEBvhQ=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/Ext-RKSJ-V.bcmap
// module id = 633
// module chunks = 502